import React from 'react';
import PropTypes from 'prop-types';
import {Text, TextAreaField, Button} from '@albert-io/atomic';

import 'client/SchoolAdministration/School/ManageStaff/Staff/UpdateTeachers/update-teachers.scss';

const EmailField = ({
  activeCardRef,
  emailError,
  emailField,
  handleChange,
  handleKeyPress,
  handleSubmit,
  refreshTeacherListRef,
  showEmailTable
}) => {
  return (
    <>
      {activeCardRef === refreshTeacherListRef ? (
        <Text>Enter all email addresses for your new teacher list:</Text>
      ) : (
        <Text>Enter all email addresses to add to your teacher list:</Text>
      )}
      <TextAreaField
        border
        placeholder='Separate emails by a comma, space, or semicolon.'
        size='l'
        type='text'
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        error={Boolean(emailError)}
        message={emailError}
        value={emailField}
      />
      <AddAndContinue
        emailField={emailField}
        handleSubmit={handleSubmit}
        showEmailTable={showEmailTable}
      />
    </>
  );
};

EmailField.propTypes = {
  activeCardRef: PropTypes.object,
  emailError: PropTypes.string,
  emailField: PropTypes.string,
  handleChange: PropTypes.func,
  handleKeyPress: PropTypes.func,
  handleSubmit: PropTypes.func,
  refreshTeacherListRef: PropTypes.any,
  showEmailTable: PropTypes.bool
};

const AddAndContinue = ({emailField, handleSubmit, showEmailTable}) => {
  return (
    <>
      {showEmailTable ? (
        <>
          {emailField.length ? (
            <div className='u-text-align_right'>
              <Button className='u-mar-t_2 u-mar-b_2' onClick={handleSubmit}>
                Add More
              </Button>
            </div>
          ) : (
            <div className='u-text-align_right'>
              <Button disabled className='u-mar-t_2 u-mar-b_2' onClick={handleSubmit}>
                Add More
              </Button>
            </div>
          )}
        </>
      ) : (
        <div className='u-text-align_right'>
          <Button className='u-mar-t_2 u-mar-b_2' onClick={handleSubmit}>
            Add &amp; Continue
          </Button>
        </div>
      )}
    </>
  );
};

AddAndContinue.propTypes = {
  emailField: PropTypes.string,
  handleSubmit: PropTypes.func,
  showEmailTable: PropTypes.bool
};

export default EmailField;
